module.exports = __webpack_public_path__ + "assets/img/dulianti.31d1aefe.png";